import { render, staticRenderFns } from "./xgLoadlw.vue?vue&type=template&id=da4323d6&"
import script from "./xgLoadlw.vue?vue&type=script&lang=js&"
export * from "./xgLoadlw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports